export default __webpack_public_path__ + "static/media/areax_logo.aaf0c84a.svg";